export default "/_next/static/9cd55451954808e48141416197770d1e.png";